import React from 'react';
import { CSVLink } from 'react-csv';
import Chip from '@mui/material/Chip';
import clsx from 'clsx';
import Tooltip from '@mui/material/Tooltip';
import { WorkItem } from '../../../features/workitems/Types';
import { useStyles } from '../../../features/workitems/WorkItems.Styles';

interface Props {
  workItems: WorkItem[];
}

function extractContent(s: string) {
  const span = document.createElement('span');
  span.innerHTML = s;
  return span.textContent || span.innerText;
}

// exports a link that provides the current list as a csv download
function CSVExporter(props: Props) {
  const classes = useStyles();
  const { workItems } = props;
  const data: any = [];

  // the variable columns defines which values are written into the csv file.
  const columns = [
    'productLine',
    'products',
    'version',
    'component',
    'title',
    'id',
    'type',
    'reportedVersion',
    'tags',
    'date',
    'developmentStatus',
    'incidentNumber',
  ];

  // adds a workitem as a row to the data variable
  const addToData = (wi: WorkItem) => {
    const row: string[] = [];
    columns.forEach((column) => row.push((wi[column as keyof WorkItem]).toString()));
    row[4] = extractContent(row[4]); // title
    row[7] = row[7].replaceAll(';', ','); // reportedVersion
    if (parseInt(row[9], 10) > 0) { // date
      row[9] = new Date(parseInt(row[9], 10)).toISOString().split('T')[0].toString();
    } else {
      row[9] = '';
    }
    data.push(row);
  };

  workItems.forEach((wi) => addToData(wi));

  return (
    /* eslint-disable-next-line react/jsx-props-no-spreading */
    <CSVLink
      className={classes.noLinkStyle}
      filename="Changelogs_Export.csv"
      enclosingCharacter=" "
      separator=";"
      data={data}
      headers={columns.map((c) => (c !== 'products' ? c : 'product'))}
    >
      <Tooltip title="Export current list to CSV" placement="bottom">
        <Chip
          label="Export CSV"
          className={clsx(classes.filterButton)}
          variant="outlined"
          size="small"
          color="primary"
        />
      </Tooltip>
    </CSVLink>
  );
}

export default CSVExporter;
